import { useState } from 'react';
import { Snackbar } from '@linearb/linui-common/base';
import useUserProfile from 'views/root/views/home/hooks/useUserProfile';
import { Stack } from '@mui/material';
import UserProfileWizardAnimated from './UserProfileWizardAnimated';
import { LBButton } from '@linearb/buzz';

/**
 * UserProfileWizardWrapper
 */
function UserProfileWizardWrapper({
  openUserProfileWizard,
  setOpenUserProfileWizard
}): JSX.Element {
  const { onSave } = useUserProfile();
  const [openSnoozeSnackBar, setOpenSnoozeSnackBar] = useState(false);
  const [openCompleteSnackBar, setOpenCompleteSnackBar] = useState(false);

  return (
    <>
      <UserProfileWizardAnimated
        openUserProfileWizard={openUserProfileWizard}
        setOpenUserProfileWizard={setOpenUserProfileWizard}
        setOpenSnoozeSnackBar={setOpenSnoozeSnackBar}
        setOpenCompleteSnackBar={setOpenCompleteSnackBar}
      />
      <Snackbar
        type='info'
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={openSnoozeSnackBar}
        handleClose={() => setOpenSnoozeSnackBar(false)}
        autoHideDuration={6000}
        data-cy='snooze-user-profile-snack-bar'
      >
        <Stack direction={'row'} alignItems='center' gap={2}>
          User profile setup will show again next week.
          <LBButton
            size='sm'
            onClick={() => {
              onSave({ doNotShowAgain: true });
              setOpenSnoozeSnackBar(false);
            }}
            data-cy='user-profile-dont-show-again-btn'
          >
            Don't show again
          </LBButton>
        </Stack>
      </Snackbar>
      <Snackbar
        type='success'
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={openCompleteSnackBar}
        handleClose={() => setOpenCompleteSnackBar(false)}
        autoHideDuration={6000}
        data-cy='complete-user-profile-snack-bar'
      >
        <Stack direction={'row'} alignItems='center' gap={2}>
          User profile successfully updated! you can always edit your User
          Profile from the user avatar
        </Stack>
      </Snackbar>
    </>
  );
}

export default UserProfileWizardWrapper;
